(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frd-image-gallery"] && !Shopify.designMode) return;
  try {
    
// Position lookup map to translate dropdown values to actual positions
const POSITION_MAP = {
  'center': 'center center',
  'top': 'center top',
  'top_right': 'right top',
  'top_left': 'left top',
  'middle_right': 'right center',
  'middle_left': 'left center',
  'bottom': 'center bottom',
  'bottom_right': 'right bottom',
  'bottom_left': 'left bottom'
};

// Main init function that runs on page load, resize, and when sections load
function frdInitGallery() {
  const galleryItems = document.querySelectorAll('.frd-custom-gallery-item img');
  
  galleryItems.forEach(img => {
    applyImagePositioning(img);
  });

  // Initialize mobile layout
  organizeMobileLayout();
  
  // Add a resize handler to update positions when screen size changes
  if (!window.frdResizeListenerAdded) {
    window.addEventListener('resize', debounce(() => {
      const galleryItems = document.querySelectorAll('.frd-custom-gallery-item img');
      galleryItems.forEach(img => {
        applyImagePositioning(img);
      });
      
      // Reorganize mobile layout on resize
      organizeMobileLayout();
    }, 100));
    window.frdResizeListenerAdded = true;
  }
}

// Debounce function to prevent excessive resize event firing
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// Apply positioning to a single image
function applyImagePositioning(img) {
  if (!img) return;
  
  // Get dropdown position values
  const desktopPosition = img.getAttribute('data-desktop-position') || 'center';
  const mobilePosition = img.getAttribute('data-mobile-position') || 'center';
  
  // Get custom position values, parse as integers with fallback to 50
  const desktopX = parseInt(img.getAttribute('data-desktop-x')) || 50;
  const desktopY = parseInt(img.getAttribute('data-desktop-y')) || 50;
  const mobileX = parseInt(img.getAttribute('data-mobile-x')) || 50;
  const mobileY = parseInt(img.getAttribute('data-mobile-y')) || 50;
  
  // Check if we should use custom positioning
  const useCustomDesktop = desktopX !== 50 || desktopY !== 50;
  const useCustomMobile = mobileX !== 50 || mobileY !== 50;
  
  // Determine if we're on mobile
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  
  // Set the appropriate object-position based on device and custom values
  if (isMobile) {
    if (useCustomMobile) {
      // Use custom mobile position
      img.style.objectPosition = `${mobileX}% ${mobileY}%`;
    } else if (useCustomDesktop) {
      // Fallback to custom desktop if no custom mobile
      img.style.objectPosition = `${desktopX}% ${desktopY}%`;
    } else {
      // Use dropdown mobile position
      img.style.objectPosition = POSITION_MAP[mobilePosition];
    }
  } else {
    if (useCustomDesktop) {
      // Use custom desktop position
      img.style.objectPosition = `${desktopX}% ${desktopY}%`;
    } else {
      // Use dropdown desktop position
      img.style.objectPosition = POSITION_MAP[desktopPosition];
    }
  }
}

// Function to organize gallery items into mobile rows with custom widths
function organizeMobileLayout() {
  // Only apply on mobile viewports
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  
  const gallery = document.querySelector('.frd-custom-masonry-gallery');
  if (!gallery) return;
  
  // Get all gallery items
  const items = Array.from(gallery.querySelectorAll('.frd-custom-gallery-item'));
  if (items.length === 0) return;
  
  // Clear existing layout wrappers
  const existingWrappers = gallery.querySelectorAll('.frd-mobile-row-1, .frd-mobile-row-2, .frd-mobile-row-3, .frd-mobile-remaining');
  existingWrappers.forEach(wrapper => {
    // Move all children back to gallery before removing wrapper
    while (wrapper.firstChild) {
      gallery.appendChild(wrapper.firstChild);
    }
    wrapper.remove();
  });
  
  // Create row wrappers
  const row1 = document.createElement('div');
  row1.className = 'frd-mobile-row-1';
  
  const row2 = document.createElement('div');
  row2.className = 'frd-mobile-row-2';
  
  const row3 = document.createElement('div');
  row3.className = 'frd-mobile-row-3';
  
  const remaining = document.createElement('div');
  remaining.className = 'frd-mobile-remaining';
  
  // Clear the gallery
  while (gallery.firstChild) {
    gallery.removeChild(gallery.firstChild);
  }
  
  // Organize items into rows
  // First row: 2 items
  for (let i = 0; i < Math.min(2, items.length); i++) {
    // Apply mobile width class if set
    const widthClass = items[i].getAttribute('data-mobile-width') || 'default';
    items[i].className = items[i].className.replace(/\bfrd-mobile-width-\S+/g, '');
    items[i].classList.add(`frd-mobile-width-${widthClass}`);
    row1.appendChild(items[i]);
  }
  
  // Second row: 3 items
  for (let i = 2; i < Math.min(5, items.length); i++) {
    // Apply mobile width class if set
    const widthClass = items[i].getAttribute('data-mobile-width') || 'default';
    items[i].className = items[i].className.replace(/\bfrd-mobile-width-\S+/g, '');
    items[i].classList.add(`frd-mobile-width-${widthClass}`);
    row2.appendChild(items[i]);
  }
  
  // Third row: 3 items
  for (let i = 5; i < Math.min(8, items.length); i++) {
    // Apply mobile width class if set
    const widthClass = items[i].getAttribute('data-mobile-width') || 'default';
    items[i].className = items[i].className.replace(/\bfrd-mobile-width-\S+/g, '');
    items[i].classList.add(`frd-mobile-width-${widthClass}`);
    row3.appendChild(items[i]);
  }
  
  // Remaining items
  for (let i = 8; i < items.length; i++) {
    remaining.appendChild(items[i]);
  }
  
  // Add rows to gallery
  if (row1.children.length > 0) gallery.appendChild(row1);
  if (row2.children.length > 0) gallery.appendChild(row2);
  if (row3.children.length > 0) gallery.appendChild(row3);
  if (remaining.children.length > 0) gallery.appendChild(remaining);
}

// Initialize when the DOM is ready
document.addEventListener('DOMContentLoaded', frdInitGallery);

// Initialize when Shopify sections load
document.addEventListener('shopify:section:load', frdInitGallery);

// Initialize when blocks are selected in theme editor
document.addEventListener('shopify:block:select', function(event) {
  const img = event.target.querySelector('img');
  if (img) {
    applyImagePositioning(img);
  }
  
  // Update mobile layout when block settings change
  organizeMobileLayout();
});

  } catch(e) { console.error(e); }
})();
})();
